import { useEffect, useState } from 'react'
import AbmTable from '../components/AbmTable'
import Modal from '../components/Modal'
import Boton from '../components/Boton'
import { rolesApi } from '../api/roles'
import { font } from '../design/tokens'

const EMPTY = { name: '' }

export default function RolesPage() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(null)        // 'new' | row
  const [form, setForm] = useState(EMPTY)
  const [err, setErr] = useState('')
  const [saving, setSaving] = useState(false)

  const cargar = () => {
    setLoading(true)
    rolesApi.listar()
      .then(({ data }) => setRows(data.data || data || []))
      .finally(() => setLoading(false))
  }
  useEffect(cargar, [])

  const openCreate = () => { setForm({ name: '' }); setErr(''); setModal('new') }
  const openEdit   = (r) => { setForm({ name: r.name }); setErr(''); setModal(r) }

  const handleSave = async (e) => {
    e.preventDefault(); setErr(''); setSaving(true)
    try {
      if (modal === 'new') await rolesApi.crear(form)
      else                  await rolesApi.editar(modal.id, form)
      setModal(null); cargar()
    } catch (error) {
      setErr(error.response?.data?.message || 'Error al guardar.')
    } finally { setSaving(false) }
  }

  const remove = async (r) => {
    try { await rolesApi.eliminar(r.id); cargar() }
    catch (error) { alert(error.response?.data?.message || 'No se pudo eliminar.') }
  }

  const columns = [
    {
      key: 'name',
      label: 'Nombre',
      render: v => <code style={{ fontFamily: font.mono, fontSize: 13, fontWeight: 500 }}>{v}</code>,
    },
    { key: 'guard_name', label: 'Guard' },
    {
      key: 'usuarios_count',
      label: 'Usuarios',
      render: v => v > 0 ? v : <span style={{ color: '#cbd5e1' }}>0</span>,
    },
  ]

  return (
    <div>
      <AbmTable
        title="Roles"
        columns={columns}
        rows={rows}
        loading={loading}
        onCreate={openCreate}
        onEdit={openEdit}
        onDelete={remove}
      />
      {modal && (
        <Modal
          title={modal === 'new' ? 'Nuevo rol' : 'Editar rol'}
          onClose={() => setModal(null)}
          maxWidth="420px"
        >
          <form onSubmit={handleSave} style={st.form}>
            <div>
              <label style={st.label}>Nombre del rol *</label>
              <input
                style={st.input}
                value={form.name}
                onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                placeholder="ej: vendedor_premium"
                required
                autoFocus
              />
              <p style={st.hint}>
                Se usa como identificador en middlewares y permisos de menú. Ej: <code>administrador</code>, <code>ventas</code>, <code>logistica</code>.
              </p>
            </div>
            {err && <div style={st.err}>{err}</div>}
            <div style={st.actions}>
              <Boton variante="ghost" type="button" onClick={() => setModal(null)}>Cancelar</Boton>
              <Boton variante="primary" type="submit" disabled={saving}>{saving ? 'Guardando…' : 'Guardar'}</Boton>
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}

const st = {
  form:   { display: 'flex', flexDirection: 'column', gap: 14 },
  label:  { display: 'block', fontWeight: 600, fontSize: 13, color: '#374151', marginBottom: 4 },
  input:  { width: '100%', padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box' },
  hint:   { fontSize: 12, color: '#64748b', margin: '6px 0 0' },
  err:    { background: '#fee2e2', color: '#991b1b', padding: '8px 12px', borderRadius: 6, fontSize: 13 },
  actions:{ display: 'flex', justifyContent: 'flex-end', gap: 8 },
}
